
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/captions/[language]",
      function () {
        return require("private-next-pages/captions/[language].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/captions/[language]"])
      });
    }
  